/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Workflow_Step1title1Inputs */

const zh_landing_workflow_step1title1 = /** @type {(inputs: Landing_Workflow_Step1title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`几秒钟生成教学素材`)
};

const en_landing_workflow_step1title1 = /** @type {(inputs: Landing_Workflow_Step1title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create teaching materials in seconds`)
};

const es_landing_workflow_step1title1 = /** @type {(inputs: Landing_Workflow_Step1title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea materiales didácticos en segundos`)
};

/**
* | output |
* | --- |
* | "Create teaching materials in seconds" |
*
* @param {Landing_Workflow_Step1title1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_workflow_step1title1 = /** @type {((inputs?: Landing_Workflow_Step1title1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Workflow_Step1title1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_workflow_step1title1(inputs)
	if (locale === "en") return en_landing_workflow_step1title1(inputs)
	return es_landing_workflow_step1title1(inputs)
});
export { landing_workflow_step1title1 as "landing_workflow_step1Title" }